import { render } from "./AutoDeleteDate.vue?vue&type=template&id=4ed4c8f2"
import script from "./AutoDeleteDate.vue?vue&type=script&lang=js"
export * from "./AutoDeleteDate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__